export default __webpack_public_path__ + "static/media/contactUsImage.2ade1e57.JPG";